import {defineStore} from 'pinia'
import api from "../../../../vendor/xkit/js/api.js";
import {nextTick} from "vue";
import {
	store
} from "core-js/internals/reflect-metadata.js";

let $ = jQuery

export const useDataTableStore = defineStore('xkit-datatable', {
	state: () => {

		return {
			datatables: {
				// state: {},
				// rows: {},
				// wrapper_id: null,
				// $wrapper: null,
			}
		}
	},
	actions: {
		async fetch_data( id, data = {} ){
			let datatable = this.datatables[id]
			XKIT_Utils.blockUI( datatable.$wrapper )

			let urlParams = new URLSearchParams(document.location.search);
			if ( urlParams ) {
				for ( let pair of urlParams.entries() ) {
					data[ pair[0] ] = pair[1] ;
				}
			}

			data = Object.assign( {} , datatable.state.data_req, data )
			if ( ! data.pagenum && store.datatables[props.wrapper_id].pagination.current ) {
				data.pagenum = store.datatables[props.wrapper_id].pagination.current
			}


			api.post( data )
			   .then(function( res ){
				   datatable.$wrapper.unblock()
				   if ( res.data.err ) {
					   return;
				   }
				   datatable.rows = res.data.items
				   datatable.pagination = res.data.pagination

				   nextTick(function (){
					   $( '.dt-row .actions .action', datatable.$wrapper).each(function() {
						   let $action_button = $(this)
						   let $row = $action_button.parents('.dt-row').first()

						   $action_button.attr('data-id', $row.data('id') )

						   if ( $action_button.attr( 'data-xkit-open-modal' ) ) {
							   $action_button.attr('data-state', JSON.stringify( { 'id': $row.data('id') } ) )
						   }
					   })

					   if ( typeof init_xkit_modals != 'undefined' ) {
						   init_xkit_modals()
					   }
				   })
			   })
		}



	},
})